export const USER_SELECTION_TOGGLE_SPORT = 'USER_SELECTION_TOGGLE_SPORT';

export const USER_SELECTION_TOGGLE_LEAGUE = 'USER_SELECTION_TOGGLE_LEAGUE';

export const USER_SELECTION_TOGGLE_MATCH = 'USER_SELECTION_TOGGLE_MATCH';

export const USER_SELECTION_SHOW_ALL = 'USER_SELECTION_SHOW_ALL';


// WEBPACK FOOTER //
// ./js/actions/UserSelection.js